<template>
    <div class="models page">
        <img v-if="!application" src="/assets/images/talents/loader.gif">
        <div  v-if="application"  class="wrapper">
            <a :href="'/aanvraag/'+applicationId+'/pdf'" class="btn-black btn-download">{{ trans('talents.profile.download_overview') }}</a>
            <a :href="'mailto:?body=%0D%0A%0D%0AVia onderstaande link kun je de geselecteerde modellen bekijken:%0D%0A%0D%0Ahttps://talents.dutchcasting.nl/share/'+applicationId+'/favorites&subject=Selectie | '+application.description+' | Dutch Casting Agency'" class="btn-black btn-share">{{ trans('talents.profile.share_selection') }}</a>
<!--            <a :href="'/share/'+applicationId+'/favorites'" class="btn btn-orange">{{ trans('talents.profile.share_selection') }}</a></td>-->
        </div>
        <div class="wrapper" v-if="application && favorites">
            <h1 class="application-title"><a :href="'/aanvraag/'+applicationId">{{ application.description }}</a></h1>
            <div class="models-container" v-for="(proposal, proposalId) in application.roles" v-if="proposal.description.indexOf('Model handmatig') === -1">
                <h2><span class="title"><span class="proposal-date">{{proposal.created}}</span> <strong>{{proposal.description}} </strong>  </span><a :href="'/aanvraag/'+applicationId+'/'+proposalId" class="proposal-open"></a></h2>
                <div style="padding: 10px; text-align:center;color: #ff5100" v-if="!favorites[proposalId]">
                    <img src="/assets/images/talents/loader.gif" style="width:18px;">
                </div>
                <div style="padding: 10px; text-align:center;color: #ff5100" v-if="favorites[proposalId] && favorites[proposalId].length === 0">Geen selectie gemaakt</div>
                <div class="models-result wrapper">
                    <div v-for="(model, index) in favorites[proposalId]" :key="model.id" :class="'model small skip'+index" :id="'model-'+model.ID_Model">
                        <div class="model-image" @click="showModel(model)"  style="cursor: pointer">
                            <img :src="firstFoto(model)+'.jpg'" :alt="model.Voornaam +' '+model.Achternaam_letter">
                        </div>
                        <div @click="removeFromApplicationFavorites(proposalId, model.ID_Model)" class="footer active" @click.stop="">{{ model.Voornaam }} {{ model.Achternaam_letter }}</div>
                    </div>
                </div>
            </div>
        </div>
        <favorites-confirm v-if="showConfirmDeleteFavorite" :mode="mode"></favorites-confirm>
        <div class="application-send">
            <div class="wrapper">
                <div style="padding: 10px 0">
                    <div class="application-remark">
                        <textarea name="application-remark" placeholder="Opmerkingen over uw selectie" v-model="remark"></textarea>
                    </div>
                    <button type="submit" class="btn btn-orange btn-finish-application" @click="sendProposal">Verstuur selectie</button>
                </div>
            </div>
        </div>
        <div class="proposal-finished">
            <div class="wrapper">
                Hartelijk dank voor het versturen van jullie selectie!
                Ik ga er direct mee aan de slag<br><br>
                Mochten er op dit moment nog vragen zijn, bel mij dan gerust
                <br><br>
                <img :src="'/assets/images/talents/bookers/'+booker+'.jpg'" class="booker-image"><br/>
                <a :href="'mailto:'+bookerEmail" style="color: #fff;">{{bookerEmail}}</a><br/>
                +31 20 420 38 21
            </div>

        </div>
        <div id="models-detail-overlay" ref="detailContainer">
            <model v-if="model" :model="model"></model>
       </div>
    </div>
</template>
<script type='text/babel'>
    import {mapState} from 'vuex'
    import ProposalMenu from "./ProposalMenu";
    import FavoritesConfirm from './FavoritesConfirm.vue'
    import Model from "./ModelQuick.vue"

    export default {
        components: {
            ProposalMenu,
            FavoritesConfirm,
            Model,
        },
        props: {
            mode: {default: 'default'},
            applicationId: {default: null},
            booker: {default: 'Vincent Wats'},
            bookerEmail: {default: 'vincent@ducthcasting.nl'},
        },
        data: function () {
            return {
                remark: '',
                model: null
            }
        },
        created() {
            this.fetchApplication(this.applicationId)
        },
        mounted() {
            //this.setFavoritesIds()
            this.$on('setFavoritesForProposal', (value) => this.setFavoritesForProposal(value))
            this.$on('removeModel', (value) => this.removeModel())

        },

        computed: {
            ...mapState(['application']),
            ...mapState(['applicationFavorites']),
            ...mapState(['showConfirmDeleteFavorite']),
            ...mapState(['deleteFavoriteId']),
            ...mapState(['project']),
            favorites() {
                return this.applicationFavorites;
            }
            // favoriteIds() {
            //     return _.filter(this.$cookies.keys(), function (f) {
            //         return f.indexOf('favorites_') === 0
            //     });
            // },
        },
        watch: {
            application() {
                this.setProposals()
            }
        },
        methods: {
            showModel(model) {
                this.model = model
                setTimeout(function () {
                    document.body.classList.add('noscroll')
                    TweenMax.to(this.$refs.detailContainer, 0.6, {top: 0})
                }.bind(this), 500)
            },
            removeModel(){
                setTimeout(function () {
                    this.model = null
                }.bind(this), 3)
            },
            setProposals() {
                _.each(this.application.roles, function (proposal) {
                    this.setFavoritesForProposal(proposal.uuid)
                }.bind(this))
            },
            setFavoritesForProposal(proposalId) {
                let modelIds = _.map(_.filter(this.application.roles[proposalId].models, {'favorite': '1'}), 'ID_Model');
                modelIds = modelIds.length > 0 ? modelIds : 'none'
                let data = {skip: 0, model_ids: modelIds}
                axios.post('/get-models', data).then((response) => {
                    this.$store.dispatch('setApplicationFavorites', {id: proposalId, models: response.data})
                })
            },
            removeFromApplicationFavorites(proposalId, modelId) {
                let elModel = document.getElementById('model-' + modelId)
                elModel.classList.add('faded')
                this.$store.dispatch('setProject', proposalId)
                this.removeFromFavorites(modelId, this.showConfirmDeleteFavorite)
            },
            sendProposal() {
                document.getElementById('talents').classList.add('proposal-done')
                axios.post('/aanvraag/verstuur', {remark: this.remark, applicationID: this.applicationId}).then((response) => {
                    console.log(response)
                })
            }
        },
    }
</script>
